import { createFileRoute } from "@tanstack/react-router";
import { MembershipCheckout } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";
import { publicSubscriptionPlansQuery } from "@/lib/subscriptionPlansQuery";

export const Route = createFileRoute("/membership-checkout")({
  // Transactional step — kept out of the index.
  head: () => seoHead({ title: "Membership Checkout", noindex: true }),
  // Resolve plans before render: a plan query left pending during SSR was
  // handed to the browser unfinished and never settled, leaving a blank card.
  // Fails soft — the client refetches if this read cannot complete.
  loader: async ({ context }) => {
    try {
      await context.queryClient.ensureQueryData(publicSubscriptionPlansQuery);
    } catch {
      /* client refetches */
    }
    return null;
  },
  errorComponent: () => (
    <div className="mx-auto max-w-md p-8 text-center">
      <p>Checkout couldn't load. Please refresh the page.</p>
    </div>
  ),
  notFoundComponent: () => (
    <div className="mx-auto max-w-md p-8 text-center">
      <p>Page not found.</p>
    </div>
  ),
  component: MembershipCheckout,
});
